export default "__VITE_ASSET__C$DEcR6$__"